import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import Button from '../../Button';
import ArrowRight from '../../../icons/ArrowRight';

const propTypes = {
  groupedReactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      system_sticker: PropTypes.shape({
        id: PropTypes.string,
      }),
      reactions_count: PropTypes.number,
      has_account_reaction: PropTypes.bool,
    }),
  ),
  onGroupedReactionsClick: PropTypes.func,
  isUploader: PropTypes.bool,
};

const FileGroupedReactions = ({
  groupedReactions,
  onGroupedReactionsClick,
  isUploader,
}) => {
  // Because 1 reaction = 1 account, the total reactions = total accounts reacting.
  const totalReactions = groupedReactions.reduce((acc, record) => {
    return acc + record.reactions_count;
  }, 0);

  const latestReactions = groupedReactions.slice(0, 3);

  return (
    <Button
      btnStyle="reset"
      onClick={onGroupedReactionsClick}
      className="file-grouped-reactions"
    >
      {latestReactions.map(reaction => (
        <img
          key={reaction.system_sticker.id}
          src={reaction.system_sticker.asset_image.url}
          alt=""
        />
      ))}
      <span className="file-grouped-reactions-total">
        {totalReactions} {pluralize('person', totalReactions)}
      </span>{' '}
      <span>reacted to {isUploader ? 'your' : 'this'} photo.</span>
      <ArrowRight size={15} color="#0e84fe" className="ml-auto" />
    </Button>
  );
};

FileGroupedReactions.propTypes = propTypes;

export default FileGroupedReactions;
